import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  InputGroup,
  Pagination,
  Button,
  Collapse,
  ButtonGroup,
} from "react-bootstrap";
import { FaSearch, FaTrash, FaPrint,FaStore } from "react-icons/fa";
import "./QuotationListOne.css";
import {
  handleChangeSearch,
  handleGetQuotations,
  handleNext,
  handlePrev,
  handleQuoteDelete,
  useHandleUserOrderPath,
  useDefaultLoad,
  handleGetAddons_list,
  updateStatus,handleStatus_Label
} from "../../../API/Model/quotaionModel";
import useToast from "../../../API/GlobalHooks/useToast";
import { formatUTCDate_dmy } from "../../../MIS/Global";
import { useModal } from "../../ConfirmationModal/ModalContext";
import QuotationView from "./QuotationView/QuotationView";
import OrderDaysModal from "./OrderDaysModal";
import MobileNumberModal from "./MobileNumberModal";
import { useLocation, useNavigate } from "react-router-dom";
import PrintAddonModal from "./PrintAddonModal";


const QuotationListOne = ({quote_type=0}) => {
  const navigate=useNavigate();
  const location = useLocation();
  const showToast = useToast();
  const { showModal } = useModal();
  const [search, setSearch] = useState("");
  const [quotations, setQuotations] = useState([]);
  const [totalPage, setTotalPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [filter, setFilter] = useState({ limit: 25, page: page,quote_type:quote_type });
  const [expandedId, setExpandedId] = useState(null); // accordion control
  const [showOrderModal, setShowOrderModal] = useState(false);
  const [completeDays, setCompleteDays] = useState("");
  const [showStoreModal, setStoreShowModal] = useState(false);
  const [hideAdminElements, setHideAdminElements] = useState(true);
  const [addons, setAddons] = useState([]);
  const [singleQuote, setSingleQuote] = useState({});
  const [statusLoading, setStatusLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [showPrintAddonModal, setShowPrintAddonModal] = useState(false);

  useEffect(() => {
    handleGetAddons_list({setAddons,setLoading})
  },[])
  

  useHandleUserOrderPath({location,
    setHideAdminElements});

  useDefaultLoad({
    filter,
    setQuotations,
    setLoading,
    showToast,
    setTotalPage,
    page,
  });

  const handleAcceptClick = (item) => {
    setSingleQuote(item)
    setStatus(item?.quote_status)
    setShowOrderModal(true);
  };
  const handlePrintAddonClick = (item) => {
    setSingleQuote(item)    
    setShowPrintAddonModal(true);
  };

  const getDueDate = (days) => {
    if (!days) return null;
  
    const dueDate = new Date();
    dueDate.setDate(dueDate.getDate() + parseInt(days));
  
    // Format: YYYY-MM-DD
    const year = dueDate.getFullYear();
    const month = String(dueDate.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
    const day = String(dueDate.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  };
  const handleConfirmDays = (days) => {
    // Do something with the selected days
      let due_date=getDueDate(days);      
      updateStatus({quote:singleQuote,quotations,setQuotations,
        showToast,due_date,setStatusLoading,status })     
  };

  const handleMobileSubmit = (mobile) => {
    console.log("Mobile submitted:", mobile);
    // handle API call or logic
  };
  return (
    <>
    <Container fluid className="quotation-container">
      {/* Header */}
      <Row className="align-items-center sticky-header py-2 bg-white border-bottom">
        <Col>
          <h5 className="m-0">Order List</h5>
        </Col>
        <Col className="d-flex justify-content-end align-items-center">
          <InputGroup size="sm" style={{ maxWidth: 400 }}>
            <InputGroup.Text>
              <FaSearch />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Search by keywords..."
              onChange={(e) => {
                let value = e.target.value;
                handleChangeSearch({ value, setSearch, setFilter });
              }}
            />
            <Button
              variant="primary"
              type="button"
              onClick={() => {
                let data = { ...filter, page: 1 };
                handleGetQuotations({
                  data,
                  setQuotations,
                  setLoading,
                  showToast,
                  setTotalPage,
                });
              }}
            >
              Search
            </Button>
          </InputGroup>
          <div className="d-flex align-items-center ms-3">
            <Pagination size="sm" className="mb-0 mt-2 mt-md-0">
              <Pagination.Prev
                disabled={page === 1}
                onClick={() => handlePrev({ setPage, page, setFilter })}
              />
              <Pagination.Item active>{`${page}/${totalPage}`}</Pagination.Item>
              <Pagination.Next
                disabled={page === totalPage}
                onClick={() =>
                  handleNext({ setPage, page, totalPage, setFilter })
                }
              />
            </Pagination>
          </div>
        </Col>
      </Row>

      {/* Cards */}
      {loading ? (
        <div className="d-flex justify-content-center align-items-center py-5">
          <span
            className="text-primary spinner-border spinner-border-sm me-2"
            role="status"
            aria-hidden="true"
            style={{ width: "2rem", height: "2rem" }}
          ></span>
        </div>
      ) : quotations.length === 0 ? (
        <div className="text-center text-muted py-4">
          <h5>No records found</h5>
        </div>
      ) : (
        <div className="scrollable-content mt-2">
          {quotations.map((quote, idx) => {
            const isExpanded = expandedId === quote.id;
            return (
              <div key={quote.id} className="mb-3">
                {/* Sticky Card */}
                <Card
                  className={`shadow-sm small-card card-hover ${
                    isExpanded ? "sticky-expanded" : ""
                  } ${idx % 2 === 0 ? "card-alt" : ""}`}
                >
                  <Card.Body
                    className="py-2 px-3 position-relative"
                    onClick={() =>
                    { 
                      hideAdminElements?
                      setExpandedId(isExpanded ? null : quote.id)
                      :setExpandedId(null)
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div className={`action-buttons ${hideAdminElements?"d-none":""}`} onClick={(e) => e.stopPropagation()}>
                    <Button
                          variant={"outline-success"}
                          className={`tiny-accept-btn`}
                          onClick={()=>{
                            navigate("/order-process")
                          }}
                        >
                          Edit
                        </Button>
                     <Button
                          variant={"outline-primary"}
                          className={`tiny-accept-btn`}
                          onClick={()=>{
                            navigate("/view-bill")
                          }}
                        >
                          View
                        </Button>
                    </div>
                    <div
                      className={`action-buttons ${hideAdminElements?"":"d-none"}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Button
                        variant="link"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          showModal({
                            title: "Delete Confirmation",
                            message:
                              "Are you sure? This quotation will be permanently removed.",
                            onConfirm: () => {
                              handleQuoteDelete({
                                quote,
                                quotations,
                                setQuotations,
                                showToast,
                              });
                            },
                            confirmText: "Yes",
                            cancelText: "No",
                          });
                        }}
                      >
                        <FaTrash size={14} className="text-danger" />
                      </Button>
                      <Button
                        variant="link"
                        size="sm"
                        onClick={(e) => {
                          e.stopPropagation();
                          setStoreShowModal(true)
                        }}
                      >
                        <FaStore size={18} className="text-secondary" />
                      </Button>
                    </div>

                    <Row>
                      <Col md={4}>
                        <div className="d-flex gap-1 align-items-center">
                          <strong className="text-primary">
                            {quote.quote_no}
                          </strong>
                          <span
                            className={`badge text-center ${handleStatus_Label(quote?.quote_status)}`}
                          >
                            {quote?.quote_status}                            
                          </span>
                        </div>
                        <div className="text-muted small">
                          {quote.party_name} | {quote.party_mob}
                        </div>
                        <div>
                          <span className="fw-bold text-muted small">
                            {formatUTCDate_dmy(quote.quote_date)}
                          </span>
                        </div>
                      </Col>
                      <Col md={4}>
                        <div className="d-flex gap-1 align-items-center">
                          <strong className="text-dark">
                            {quote?.shop_name || "Shop Name"}
                          </strong>
                        </div>
                        <div className="text-muted small">
                          {quote.party_address}
                        </div>
                        <div className="text-muted small fw-bold">
                          {quote.party_state} | {quote.party_city} |{" "}
                          {quote.party_pinCode}
                        </div>
                      </Col>
                      <Col
                        md={4}
                        className="text-muted small d-flex justify-content-between"
                      >
                        <span className="fw-bold text-success">
                          ₹
                          {Number(quote.grand_total).toLocaleString("en-IN", {
                            minimumFractionDigits: 2,
                          })}
                        </span>
                      </Col>
                    </Row>
                    {/* Accept button at bottom right */}
                    <div
                      className={`accept-button-wrapper ${hideAdminElements?"":"d-none"}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <ButtonGroup size="sm">
                        <Button
                          variant={"outline-primary"}
                          className={`tiny-accept-btn`}
                          onClick={(e)=>{                            
                              handleAcceptClick(quote)                            
                          }}
                          
                        >
                          Status
                        </Button>
                        <Button
                          variant={"outline-secondary"}
                          className={`tiny-accept-btn ${quote_type==0?'d-none':''}`}
                          onClick={() => {
                            handlePrintAddonClick(quote)
                          }}
                        >
                          Print Addon({quote?.prints?.length})
                        </Button>
                      </ButtonGroup>
                    </div> 
                  </Card.Body>
                </Card>

                {/* Collapsible Section */}
                <Collapse in={isExpanded}>
                  <div className="quotation-view-wrapper">
                    <QuotationView quote={quote} addons={addons}/>
                  </div>
                </Collapse>
              </div>
            );
          })}
        </div>
      )}
    </Container>
    <OrderDaysModal
        show={showOrderModal}
        onClose={() => setShowOrderModal(false)}
        onConfirm={handleConfirmDays}
        completeDays={completeDays}
        setCompleteDays={setCompleteDays}
        singleQuote={singleQuote}
        status={status}
        setStatus={setStatus}
      />

      <MobileNumberModal
        show={showStoreModal}
        handleClose={() => setStoreShowModal(false)}
        onSubmitMobile={handleMobileSubmit}
      />

    <PrintAddonModal
      show={showPrintAddonModal}
      handleClose={() => setShowPrintAddonModal(false)}
      singleQuote={singleQuote}
      // addons={[]}
    />
    </>
  );
};

export default QuotationListOne;
